import { createSelector } from "reselect";
import getUser from "../base_getters/get_user";
import { isHxAuthUser } from "avvir";

const getHxAuthUser = createSelector([
  getUser
], (user) => (isHxAuthUser(user) && user?.hxAuthUser) || null);

export default getHxAuthUser;
